import {
  STORE_MODULE_LISTINGS,
  STORE_PLAN_PRICES,
  STORE_QUOTA_PACKAGES,
} from './storeListings';

/** Build a store-catalog-shaped object from catalog registry + entitlements (cabinet / support). */
export function buildStoreCatalogFromRegistry(registry, entitlements) {
  if (!registry || !entitlements) return null;

  return {
    entitlements: {
      plan: entitlements.plan,
      modules: entitlements.modules,
      quotas: entitlements.quotas,
    },
    modules: registry.modules || [],
    plans: registry.plans || [],
    quotas: registry.quotas || [],
    listings: STORE_MODULE_LISTINGS,
    quotaPackages: STORE_QUOTA_PACKAGES,
    planPrices: STORE_PLAN_PRICES,
  };
}
